<template lang="pug">
  div
    filter-table(layout="text" @inputSearchFilter="inputSearchFilter" v-if="!loading")
    ods-icon(name="loading" size="50" v-else)
    ods-table(
      v-loading="loading"
      style='width: 100%; min-width: 1100px'
      height="60vh"
      max-height="50vh"
      size="medium"
      :data='tableDataToRender')
      ods-table-column(prop='CUENTA' :label="$t('loyalty.loyaltyAccount')" width="190px")
        template(slot-scope="scope")
          div {{ scope.row.codcuent }}
      ods-table-column(prop='IDCLIENTE' :label="$t('loyalty.dni')" min-width="190px")
        template(slot-scope="scope")
          ods-tag(type="info" size="medium") {{ scope.row.desctidc }}: {{ scope.row.idclient }}
      ods-table-column(prop='CLIENTE' :label="$t('loyalty.client')")
        template(slot-scope="scope")
          div {{ scope.row.cliente }}
      ods-table-column(prop='ESTADO' :label="$t('loyalty.currentstate')" width="140px")
        template(slot-scope="scope")
          ods-tag(size="medium" :color="scope.row.estado === 'A' ? '#79C5B4' : scope.row.estado === 'B' ? '#F7AC6F' : '#E88AA2'") {{ scope.row.estado === 'A' ? $t('loyalty.opened') : scope.row.estado === 'B' ? $t('loyalty.blocked') : scope.row.estado === 'C' ? $t('loyalty.closed') : '' }}
      ods-table-column(prop='FECHALTA' :label="$t('terminalDetail.highDate')" align="center" width="100px")
        template(slot-scope="scope")
          div {{scope.row.fechalta | formatDateLocale}}
      ods-table-column(prop='FECHBAJA' :label="$t('terminalDetail.lowDate')" align="center" width="100px")
        template(slot-scope="scope")
          div {{scope.row.fechbaja | formatDateLocale}}
      ods-table-column(prop='FECHBLQAC' :label="$t('loyalty.accumulationBlockage')" align="center" width="100px")
        template(slot-scope="scope")
          div {{scope.row.fechblqac | formatDateLocale}}
      ods-table-column(prop='FECHBLQRD' :label="$t('loyalty.redeemableLock')" align="center" width="100px")
        template(slot-scope="scope")
          div {{scope.row.fechblqrd | formatDateLocale}}
      ods-table-column(prop='CANTPUNT' :label="$t('loyalty.totalPoints')" align="right" width="110px")
        template(slot-scope="scope")
          div {{ scope.row.cantpunt }}
      ods-table-column(width='100')
        template(slot-scope='scope')
          ods-button(type="text" icon='ods-icon-eye' @click="ver(scope.row)" )
    div.footer
      paginator-table(v-if="tableDataToRender!==null"
        :isNextPage="paginationParams.indMasDatos"
        :currentPage="paginationParams.pantPagina"
        @buttonPrevAction="getData(false)"
        @buttonNextAction="getData(true)")
    el-drawer(
      :visible.sync="showDetails"
      direction="rtl",
      :before-close="closeDetails"
      :wrapperClosable="true"
      :append-to-body="false"
      :close-on-press-escape="true"
      size="60%")
      div(slot="title")
      div.totop
        ods-tabs(v-model="activeTab")
          ods-tab-pane(:label="$t('loyalty.personalData')" name="cliente")
            detalle-cliente(v-if="activeTab === 'cliente'" :cuenta="rowSelected")
          ods-tab-pane(:label="$t('loyalty.pointsDetails')" name="detalles")
            detalle-puntos(v-if="activeTab === 'detalles'" :cuenta="rowSelected")
          ods-tab-pane(:label="$t('loyalty.transactions')" name="movimientos")
            movimientos-table(v-if="activeTab === 'movimientos'" :codCuent="rowSelected.codcuent" :cuenta="rowSelected")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'
import DetalleCliente from '@/components/loyalty/Accounts/DetalleCliente'
import DetallePuntos from '@/components/loyalty/Accounts/DetallePuntos'
import MovimientosTable from '@/components/loyalty/Accounts/MovimientosTable'

export default {
  name: 'AccountsTable',
  props: ['tipCons'],
  components: {
    'detalle-cliente': DetalleCliente,
    'detalle-puntos': DetallePuntos,
    'movimientos-table': MovimientosTable,
    'filter-table': FilterTable,
    'paginator-table': Paginator
  },
  data () {
    return {
      params: {},
      loading: true,
      tableData: null,
      tableDataToRender: null,
      paginationParams: {
        currentPage: 1,
        indMasDatos: 'N',
        claveInicio: 1,
        claveFin: 20
      },
      activeTab: '',
      showDetails: false,
      rowSelected: null
    }
  },
  computed: {
    ...mapGetters(['getCOTCFloading'])
  },
  mounted () {
    this.getData()
  },
  methods: {
    ...mapActions(['getCLTCF']),
    async getData (pagina) {
      this.loading = true
      this.params = { tipCons: this.tipCons }
      let params = this.params
      if (typeof pagina !== 'undefined') {
        // console.log('paginando')
        params = pagina ? { ...this.params, ...this.paginationParams, avanzar: true } : { ...this.params, ...this.paginationParams, retroceder: true }
      }
      this.getCLTCF(params).then(resData => {
        // console.log('getCLTCF params resData', params, resData)
        if (resData && resData.registros && resData.retorno === '000') {
          this.tableData = Array.isArray(resData.registros) ? resData.registros : [resData.registros]
          this.tableDataToRender = this.tableData
          this.paginationParams = {
            pantPagina: resData.pantPagina,
            indMasDatos: resData.indMasDatos,
            claveInicio: resData.claveInicio,
            claveFin: resData.claveFin
          }
        } else {
          this.tableData = null
          this.tableDataToRender = this.tableData
        }
        this.loading = false
        this.$emit('data-table-loaded', true)
      }).catch(err => {
        console.log('getCLTCF params error', params, err)
      })
    },
    ver (row) {
      // console.log(row)
      this.rowSelected = row
      this.verDetails()
    },
    verDetails (row) {
      this.activeTab = 'cliente'
      this.showDetails = true
    },
    closeDetails () {
      this.loading = true
      this.rowSelected = null
      this.activeTab = ''
      this.getData()
      this.showDetails = false
    },
    async inputSearchFilter (text) {
      this.tableDataToRender = await this.tableData.filter(obj => Object.values(obj).some(val => val.toString().toLowerCase().indexOf(text.toLowerCase()) > -1))
    }
  },
  watch: {
    tipCons (newVal) {
      this.loading = true
      // console.log('this.tipCons -> ', this.tipCons)
      // console.log('this.paginationParams -> ', this.paginationParams)
      if (newVal) {
        this.tableData = null
        this.tableDataToRender = null
        this.paginationParams.claveInicio = 1
        this.paginationParams.claveFin = 20
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss">
.title {
  font-size: 16px;
  color: #060E14;
  font-weight: 500;
}
.totop {
  padding-left: 30px;
  margin-right: 50px;
  margin-top: -65px;
}
</style>
